import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  data: null,
  defaultAddress: null,
  myBooks: [],
  booksLoading: true
};

const profileSlice = createSlice({
  name: "profile",
  initialState,
  reducers: {
    setProfile: (state, action) => {
      state.data = action?.payload;
    },
    updateProfile: (state, action) => {
      state.data = { ...state.data, ...action.payload }
    },
    setDefaultAddressSidebar: (state, action) => {
      state.defaultAddress = action.payload;
    },
    setBooksLoading: (state, action) => {
      state.booksLoading = !!action.payload;
    },
    setMyBooks: (state, action) => {
      state.myBooks = action.payload ?? []
    },
    addBook: (state, action) => {
      if (!!action.payload) state.myBooks = [...state.myBooks, action.payload]
    },
    updateBook: (state, action) => {
      if (!!action.payload._id) {
        state.myBooks = state.myBooks.map(book => book._id !== action.payload._id ? book : ({
          ...book,
          ...action.payload
        }))
      }
    },
    updateBookOrderDate: (state, action) => {
      const { bookId } = action.payload

      state.myBooks = state.myBooks.map(book => book._id !== bookId ? book : ({
        ...book,
        lastOrderCreatedAt: new Date().toISOString()
      }))
    },
    markStepAsVisited: (state, action) => {
      state.myBooks = state.myBooks.map(book => {
        const completedSteps = book?.completedSteps || []
        return book._id !== action.payload.id ? book : {
          ...book,
          completedSteps: [...new Set([...completedSteps, action.payload.currentStepCode])]
        }
      })
    }
  },
});

export const { setProfile, setDefaultAddressSidebar, setMyBooks, addBook, updateBook, updateProfile, setBooksLoading, markStepAsVisited, updateBookOrderDate } = profileSlice?.actions;
export default profileSlice?.reducer;
